module.exports = __webpack_public_path__ + "static/media/wheel-grooved.5631bd50.png";